import { ApplicationRef, ChangeDetectorRef, Component, EventEmitter, Input, NgZone, OnInit, Output, ViewChild } from '@angular/core';
import { MatSnackBarRef } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AuthorizeService } from 'src/app/_core/access-control/authorize.service';
import { ReportsState } from 'src/app/reports/reports.state';
import { PropertyState } from 'src/app/workspace/state/property.state';
import constants from 'src/constant.json';
import { UserState } from '../../state/user.state';
declare const google:any;


@Component({
  selector: 'app-search-propety-sheet',
  templateUrl: './search-propety-sheet.component.html',
  styleUrls: ['./search-propety-sheet.component.scss']
})
export class SearchPropetySheetComponent implements OnInit {
  @ViewChild('reportTypeChangeDialog', { static: true }) reportTypeChangeDialog: any;
  @Output() reloadAllReports: EventEmitter<any> = new EventEmitter<any>();

  showBottomSection: any;
  onDestroyNotifier$ = new Subject();
  showPropertyDetailsCard = false;
  upgradeSnackbar: MatSnackBarRef<any>;
  currentYear = new Date().getFullYear();
  regexPattern = new RegExp(`^(18\\d{2}|19\\d{2}|20(?:0\\d|1[0-9]||2[0-${this.currentYear - 2020}]))$`);
  mlsMatchNotVerified: boolean;
  mlsMatchNotFound: boolean;
  isFormValid: boolean;
  propertyMlsBoard: any;
  isLoadingCreateReport: any;
  isGenerateReport: any;

  @Input() addressType: string;
  @ViewChild('searchField') searchField: any;
  constant: any = constants;
  autoCompleteInput: string;
  queryWait: boolean;
  subpremise: string;
  selectedProperty: any;
  heading: any;
  content: any;
  isRentalAnysis: boolean;
  isEquityAnalysis: boolean;

  constructor(
    private cdr: ChangeDetectorRef,
    private appRef: ApplicationRef,
    private ngZone: NgZone,
    public userState: UserState,
    private reportsState: ReportsState,
    public authorizeService: AuthorizeService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private propertyState: PropertyState,
  ) { }

  ngOnInit() {
    this.userState.openPropertySearchSheetSubject$
      .subscribe((value) => {
      });

    this.reportsState.isLoadingCreateReportValue.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((res) => {
      this.isLoadingCreateReport = res;
      // this.cdr.detectChanges();
    });
    this.userState.PropertySearchSheet$.pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe((content) => {
        this.heading = content?.heading;
        this.content = content?.content;
        this.isRentalAnysis = content?.isRentalAnalysis;
        this.isEquityAnalysis = content?.isEquityAnalysis;
      });


  }

  ngAfterViewInit() {
    this.getPlaceAutocomplete();
  }

    async getPlaceAutocomplete() {
  const placesLibrary = await google.maps.importLibrary('places');
  const PlaceAutocompleteElement = (placesLibrary as any).PlaceAutocompleteElement;

  const autocomplete = new PlaceAutocompleteElement({
    componentRestrictions: { country: 'US' },
    types: ['geocode'], // 'establishment' / 'address' / 'geocode'
  });

  autocomplete.setAttribute('no-input-icon', '');
  autocomplete.setAttribute('no-clear-button', '');
  this.searchField.nativeElement.parentElement.replaceChild(autocomplete, this.searchField.nativeElement);

  autocomplete.addEventListener('gmp-select', async (event: any) => {
    const place = event.placePrediction.toPlace();
    await place.fetchFields({ fields: ['formattedAddress', 'addressComponents', 'location'] });

    this.invokeEvent(place);
    this.cdr.detectChanges();
  });
}


  // getPlaceAutocomplete() {
  //   const autocomplete = new google.maps.places.Autocomplete(this.searchField.nativeElement, {
  //     componentRestrictions: { country: 'US' },
  //     types: ['geocode'], // 'establishment' / 'address' / 'geocode'
  //   });

  //   google.maps.event.addListener(autocomplete, 'place_changed', async () => {
  //     const place = autocomplete.getPlace();
  //     this.invokeEvent(place);
  //     this.cdr.detectChanges();
  //   });
  // }

  async invokeEvent(place?: google.maps.places.PlaceResult) {
if (place && place['addressComponents']) {
      this.autoCompleteInput = place['formattedAddress'];
      await this.getPlaceFromGeocoder();
      this.appRef.tick();
    }
  }

  async getPlaceFromGeocoder() {
    try {
      const results = await new Promise((resolve, reject) => {
        new google.maps.Geocoder().geocode({ address: this.autoCompleteInput }, (results, status) => {
          if (status === 'OK') {
            resolve(results);
          } else {
            reject(status);
          }
        });
      });
      this.ngZone.run(() => {
        if (results && results[0]) {
          let locality: string = null;
          let subPremise: string = null;
          let streetNumber: string = null;
          let city: string = null;
          let state: string = null;
          let zip: string = null;
          results[0].address_components.forEach((result) => {
            if (result.types[0] == 'route') {
              locality = result.short_name;
            } else if (result.types.indexOf('subpremise') > -1) {
              subPremise = result.short_name;
            } else if (result.types.indexOf('street_number') > -1) {
              streetNumber = result.short_name;
            } else if (result.types.indexOf('locality') > -1 || result.types.indexOf('sublocality') > -1) {
              city = result.short_name;
            } else if (result.types.indexOf('administrative_area_level_1') > -1) {
              state = result.short_name;
            } else if (result.types.indexOf('postal_code') > -1) {
              zip = result.short_name;
            }
          });
          if (streetNumber) {
            let addressObj: any = {
              StreetNumber: streetNumber,
              StreetName: locality,
              City: city,
              State: state,
              Zip: zip,
              SubPremise: subPremise
            };
            if (subPremise) {
              let subPreFix = subPremise.toLowerCase();
              let isPrefixIncluded = this.constant.UNIT_PREFIX.some((prefix) =>
                subPreFix.includes(prefix.toLowerCase())
              );
              if (isPrefixIncluded == true) {
                addressObj.StreetName += ' ' + subPremise;
              } else {
                addressObj.StreetName += ' # ' + subPremise;
              }
            }
            this.reportsState.searchAddressValue = addressObj;
          }
        }
        this.cdr.detectChanges();
      });
    } catch (error) {
      console.error('Geocoding error:', error);
    }
  }

  closeSheet() {
    this.userState.isPropertySearchSheetOpen = false;
    this.reportsState.searchPropertyValue = null;
    this.reportsState.searchAddressValue = null;
    this.autoCompleteInput = null;
    this.reportsState.listPropertySetValue = null;
  }

  onPropertySelected(property: any) {
    this.selectedProperty = property;
  }

  toggleBottomSection() {
    this.showBottomSection = !this.showBottomSection;
  }


  analyzeProperty() {
    if (this.isRentalAnysis) {
      if (this.authorizeService.canAct('dealAnalysis')) {
        this.router.navigate([], {
          relativeTo: this.activatedRoute,
          queryParams: {
            'deal-analysis-property-id': this.selectedProperty.PMXPropertyId,
          },
          queryParamsHandling: 'merge',
        });
      }
      this.closeSheet();
    }

    if (this.isEquityAnalysis) {
      this.propertyState.equityPropertyValue = this.selectedProperty;

      this.router.navigate(['/equity-analysis'], {
        queryParams: {
          'property-id': this.selectedProperty.PMXPropertyId,
        },
      })
        .then((success) => {
          console.log('Navigation success:', success);
        })
        .catch((error) => {
          console.error('Navigation error:', error);
        });
      this.closeSheet();
    }


  }

  ngOnDestroy() {
    this.reportsState.searchAddressValue = null;
    this.reportsState.searchPropertyValue = null;
    this.reportsState.listPropertySetValue = null;
    this.reportsState.listPropertySetCount = null;
    this.userState.propertySearchSheetContent = null;
    this.onDestroyNotifier$.next();
    this.onDestroyNotifier$.complete();
  }

}
